import { GenericIdName, ObservationPointVM } from "../setup-implement/setup-implement.model";
import { GETDashboardComponentHistroyInspectionVM } from "../favourite-dialog/favourite-dialog-modal";

export class ComponentObservationPointDetails {
  public Id: number;
  public Name: string;
  public Type: string;
  public ComponentName: string;
  public WornPct: number;
  public CrackLength: string;
  public CurrentLength: string;
  public MaximumLength: string;
  public Life: number;
  public ResidualLife: number;
  public LifeTotalProjected: number;
  public InstallDate: string;
  public PartNo: string;
  public Manufacturer: string;
  public PurchaseCost: number;
  public RepairCost: number;
  public PositionX: number;
  public PositionY: number;
  public EndPositionX: number;
  public EndPositionY: number;
  public LastInspectionDate: string;
  public CompTypeName: string;
  public CompletePercentage: number;
  public ObStatus: string
  public PostEval: string;
  public PostWorn: number;
  public RepairHours: number;
  public Apporval: boolean;
  public ObPointTypeId: number;
  public ApprovalRespone: boolean;
  public CompBudgetLife: number
  public IsCrackFixed: boolean;
  public ComponentId: number;
  public StartingDim: string;
  public ObsActionHistroy: ObspointActionHistroy[];
  public Crackcomment: string
  public ObsQuestion: string;
  public SortOrder: number;
  public compOrder: number;
  public CrackSeverity: string;
  public ResidualLife120: number;
  public isCritical: boolean;
  public isGETCritical: boolean;
  public CurrentLengthNum: number;
  public InspectionDate: string;
  public SelectedObs: boolean = false;
  public IsNew: boolean;
  public CrackStatusId: number;
  public ColorCode: string;
  public CrackStatus: string;
  public LocationName: string;
  public ImageHistoryAvailable: boolean;
}

export class ObspointActionHistroy {
  public ObId: number;
  public ActionDate: Date;
  public Action: string;
  public WornPercent: number;
  public Eval: string;
  public isComponentAction: number;
  public CompId: number;
  public GETEventId: number;
}

export class OBSActionHistoryDFI {
  public ID: number
  public formUploadedId: number
  public ActionDate: Date
  public ActionDate_: string
  public WornPercent: number
  public Eval: string
  public isComponentAction: number
  public uploadID: number
  public FormName: string
  public SMU: number
  public status: number

}

export class SchematicDetails {
  public Id: number;
  public Name: string;
  public ImageName: string;
  public Data: string;
  public ImageUrl: string;
  public ObservationPoints: ObservationPointVM[];
}

export class SchematicAndObservationPointDetails {
  public Schematic: SchematicDetails;
  public ObservationPoints: ComponentObservationPointDetails[];
  public ObservationPointsHeader: ObspointActionHistroy[];
}
export class WorstEvalForCrackAndNormal {
  public Id: number
  public crackWorn: number
  public normalWorn: number
  public isCrack: boolean
}

export class NormalObsPointHistroy {
  public Id: number;
  public ObId: number;
  public compId: number;
  public obsName: string;
  public compName: string;
  public actionDate: Date;
  public SMU: number
  public Action: string;
  public Worn: number;
  public CMU: number;
  public Residual: number;
  public downTime: number;
  public Cost: number;
  public Comment: string;
  public stratX: number;
  public stratY: number;
  public endX: number;
  public endY: number;
  public cracklength: number;
  public maxL: number;
  public Rate: number;
  public dateFixed: Date;
  public Status: string;
  public Reading: number;
  public CrackObPointImagesVM: CrackObPointImagesVM[];
  public CrackSeverity: string;
  public CompBudgetLife: number;
  public ObPointTypeId: number;
  public Eval: string;
}

export class ImplementSummaryForEquipmentDetails {
  public Id: number;
  public Name: string;
  public WornPct: number;
  public TotalCracks: number;
  public TotalCrackLength: number;
  public Life: number;
  public Residual: number;
  public Residual120: number;
  public PurchaseCost: number;
  public RepairCost: number;
  public WorstNormalWorn: number;
  public WorstCrackWorn: number;
  public ReapirerName: string;
  public WorkShop: string;
  public IsInRepairer: boolean;
  public IsInventory: boolean;
  public InventoryCustomerId: number;
  public InventoryJobsiteId: number;
  public OverviewTotal: number;
  public CurrentCycleCost: number;
  public GETWorstWorn: number
  public TotalServiceHours: number
  public ImplementTypeName: string;
  public RemovelDate: string;
  public RemovelDate120: string;
  public RemovelDateTitle: string = "";
  public BuildNo: string;
  public BucketInstall: string;
  public TemplateSrNo: string;
  public CrirticalWorstWorn: number;
  public CrackExists: boolean;
  public CopyFromId: number;

}

export class ImplementForEquipmentDetails {
  public ImplementSummary: ImplementSummaryForEquipmentDetails;
  public SchematicAndObservationPoints: SchematicAndObservationPointDetails[];
}

export class ImplementForEquipmentDetailsDFI {
  public ImplementTypeName: string;
  public Implement: string;
  public WorstWorn: number;
  public Life: number;
  public Residual: number;
  public ComponentQuestions: GETDashboardComponentHistroyInspectionVM[];
}
export class InspectionHistoryDetails {
  public ImplementInspectionId: number;
  public InspectionDate: string;
  public Eval: string;
  public SMU: number;
  public ImplementName: string;
  public ActualDate: Date;
  public DocCount: number;
  public isDocAttached: boolean;
  public GETTypeId: number;
  public GETType: string;
}

export class UpdateSMUReadingModel {
  public equipmentId: number;
  public currentReading: number;
  public dateReadSMU: Date;
  public bcm: number;
  public ton: number;
  public startDate: Date;
  public endDate: Date;

}

export class ChangeMeterUnitModel {
  public equipmentId: number;
  public newSMUReadingOnNewMeter: number;
  public oldMeterSMUReading: number;
  public dateReplaced: Date;
  public Ltd: number
}

export class InspectionDetailGroupByDate {
  public InspectionDate: string;
  public ActualDate: Date;
  public InspectionsDetails: InspectionHistoryDetails[];
}

export class ImplementSortOrderForUser {
  public EquipmentId: Number
  public ImplementSortOrder: GenericIdName[]
}

export class ImplementSortOrder {
  public Id: number
  public Name: string
  public Position: number
}
export class EquipmentSMUHistoryVM {
  public equipmentId: number
  public sDate: string
  public eDate: string
  public BCM: number
  public TON: number
  public BcmTotal: number
  public TonsTotal: number
  public ActionType: string
  public sDate_: Date
  public equipmentSMU: number
}

export class EqBCMTonsVM {

  public sDate: string
  public eDate: string
  public BCM: number
  public TON: number
  public BcmTotal: number
  public TonsTotal: number
}
export class UpdateMeterHistoryVM {
  public EquipmentSMUHistory: EquipmentSMUHistoryVM[];
  public EqBCMTons: EqBCMTonsVM[];
}

export class ImplementHistoryVM {
  public Model: string
  public Unit: string
  public Serial: string
  public ImplementName: string
  public ImplementId: number
  public ActionDate: Date
  public ActionName: string
  public ActionId: number
  public Hours: number
  public HoursDiff: number
  public BCM: number
  public Tons: number
  public Cost: number
  public TotalRunningCost: number
  public comment: string
  public Location: string
  public Repairer: string
  public CycleNo: number;
  public CycleCMU: number;
  public CapitalCost: number
  public MaintenanceCost: number
  public GETCost: number
  public ActionAuto: number
  public EQBCMTonId: number


}


export class EquipmentInspectionForcastingViewModel {
  Id: number;
  JobsiteId: number;
  CreatedByUserId: number;

  HoursOfUsePerDay: number;
  UsedMonday: boolean;
  UsedTuesday: boolean;
  UsedWednesday: boolean;
  UsedThursday: boolean;
  UsedFriday: boolean;
  UsedSaturday: boolean;
  UsedSunday: boolean;
  InspectEvery: number;
  InspectEveryUnitTypeId: number;
  EnableAutoInspectionPlanner: boolean = false;
}
export class CrackObPointImagesVM {
  public Id: number
  public crackStatusHistoryID: number
  public observationInspectinId: number
  public image: string
  public IsHistory: boolean
}


export class componentListsVM {
  public Name: string
  public ID: string
  public Active: boolean
}
